import { render, staticRenderFns } from "./automotive.vue?vue&type=template&id=5d7d71f1&scoped=true"
import script from "./automotive.vue?vue&type=script&lang=js"
export * from "./automotive.vue?vue&type=script&lang=js"
import style0 from "./automotive.vue?vue&type=style&index=0&id=5d7d71f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d71f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubNav: require('/app/components/SubNav.vue').default,Sticky: require('/app/components/Sticky.vue').default,Anchor: require('/app/components/Anchor.vue').default})
